// מקור אמת יחיד לזיהוי מכשיר מובייל (טלפון/טאבלט) מול מחשב/לפטופ.
// משמש את ה-loaders של הניתוב (mobileLoader.js) ואת NavigateBasedOnDevice.
export function isMobileDevice() {
    // טלפונים ו-Android (וגם iOS ישן) — לפי User Agent.
    if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) return true;

    // הקלט העיקרי הוא מגע וללא יכולת hover ⇒ טלפון/טאבלט.
    // iPad מודרני (שמדווח על עצמו כ-"Macintosh") נתפס כאן.
    // לפטופ עם מסך מגע: הקלט העיקרי הוא טאצ'פאד/עכבר ⇒ pointer:fine / hover:hover ⇒ לא ייחשב מובייל.
    const coarse = window.matchMedia?.('(pointer: coarse)').matches;
    const noHover = window.matchMedia?.('(hover: none)').matches;
    return Boolean(coarse && noHover);
}
